import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select, Row, Col, Button } from "antd";
import { RootState } from "reducers/rootReducer";
import { formatForRedis } from "utils/appUtil";
import TimeInput from "../TimeInput";
import DateInput from "../DateInput";
const moment = require("moment");

const { Option } = Select;

const ScheduleInput = (props: any) => {
  const { value, placeholder, onChange, dispatchOptions, disabled } = props;
  const [options, setOptions] = useState(
    dispatchOptions || [
      { id: "immediate", name: "Immediate" },
      { id: "schedule", name: "Schedule" },
      { id: "deadline", name: "Deadline" },
    ]
  );

  return (
    <React.Fragment>
      {/* <Select
        showSearch
        value={value?.value}
        className="w-full"
        placeholder={placeholder}
        onChange={(value) => {
          onChange({
            value,
            type: "dispatchType",
          });
        }}
        filterOption={(input, option) =>
          (option!.children as unknown as string)
            .toLowerCase()
            .includes(input.toLowerCase())
        }
      >
        {options?.map((option, index) => (
          <Option key={index} value={option.id}>
            {option.name}
          </Option>
        ))}
      </Select> */}

<div className="tiles padding-12">
          {/* <span className="col-label">{data?.label}</span> */}
      <Row className="">
      <Col span={6} className="d-flex align-items-center">
        {/* <h5 className="mb-0">Dispatch type</h5> */}
        <span className="col-label">Dispatch type</span>
        </Col>
        {options?.map((option, index) => (
          <Col span={6}>
            <Button
              disabled={disabled}
              onClick={() => {
                onChange({
                  value: option.id,
                  type: "dispatchType",
                });
              }}
              className={`beam-btn ${
                value?.value === option.id ? "green-btn cover" : ""
              }`}
            >
              {option.name}
            </Button>
          </Col>
        ))}
      </Row>

      {value && value?.value !== "immediate" && (
        <Row className="mt-3">
          <Col span={12} className="pr-2">
            <div className="datetime-item">
              <img src="/images/date.png" alt="" />
              <DateInput
                placeholder={"Select date"}
                value={value?.date}
                disabled={disabled}
                onChange={(date) => {
                  onChange({
                    value: value?.value,
                    type: "dispatchType",
                    date,
                    time: value?.time,
                  });
                }}
              />
            </div>
          </Col>
          <Col span={12}>
            <div className="datetime-item">
              <img src="/images/date.png" alt="" />
              <TimeInput
                name={"Select time"}
                disabled={disabled}
                // value={value?.time ? moment(value?.time).format("MM/DD/YYYY HH:mm:ss"): undefined}
                value={
                  value?.time
                    ? moment(value?.time).format("HH:mm")
                    : undefined
                }
                onChange={(time) => {
                  console.log("time here", time);

                  onChange({
                    value: value?.value,
                    type: "dispatchType",
                    date: value?.date,
                    time,
                  });
                }}
              />
            </div>
          </Col>
        </Row>
      )}

      </div>
    </React.Fragment>
  );
};

export default ScheduleInput;
